import PageShell from "@/components/feature/PageShell";
import HeroSection from "@/pages/home/components/HeroSection";
import CategoryShortcuts from "@/pages/home/components/CategoryShortcuts";
import LatestGrid from "@/pages/home/components/LatestGrid";
import HotNews from "@/pages/home/components/HotNews";
import AboutSection from "@/pages/home/components/AboutSection";
import { usePageMeta } from "@/hooks/usePageMeta";

export default function Home() {
  usePageMeta({
    title: "色戒完整版无删减hd-高清电影在线观看与资讯",
    description:
      "色戒完整版无删减hd为您提供高清电影内容展示，涵盖色戒电影剧情介绍、演员信息及相关影视资讯，满足您的观影需求。",
    keywords:
      "色戒完整版无删减hd,色戒电影,完整版电影,高清电影,电影在线观看,色戒剧情,影视资讯,高清影片",
  });

  return (
    <PageShell topOffset={false}>
      <HeroSection />
      <CategoryShortcuts />
      <LatestGrid />
      <HotNews />
      <AboutSection />
    </PageShell>
  );
}